module.exports = __webpack_public_path__ + "static/media/info.27c98ac6.png";